import { render } from "./ImageUrlInput.vue?vue&type=template&id=2fb6bc42"
import script from "./ImageUrlInput.vue?vue&type=script&lang=js"
export * from "./ImageUrlInput.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__